export const fixedEnvironment = {
  sessionCookieName: 'jgconfigurator_REFRESH_SESSION',
  accessTokenHeader: 'jgconfigurator_ACCESS_SESSION',
  gqlEntryPoint: '/graphql/graphql',
  analyticsCookieName: 'jgconfigurator_ANALYTICS',
};
